module.exports = __webpack_public_path__ + "images/emoji/guardsman.2f29e539a1bac5a5e5e0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/guardsman.png
// module id = EJXo
// module chunks = 14